<script>
export default {
  name: "newPropertiesSection",
  data() {
    return {};
  },
  components: {}
};
</script>

<template>
  <el-row>
    <el-col :span="24" class="background-listing">
      <el-row>
        <el-col
          :span="24"
          style="display: flex; flex-direction: row; padding: 2px"
        >
          <span class="u-connect-p"
            >Australia's New Address for the Best in New Properties</span
          >
        </el-col>
      </el-row>
    </el-col>
  </el-row>
</template>

<style lang="postcss" scoped>
.u-connect-p {
  color: #ffffff;
  font-feature-settings: "clig" off, "liga" off;
  font: 600 34px Metropolis, sans-serif;
  display: flex;
}

.background-listing {
  display: flex;
  padding: 20px 16px;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.7) 100%
    ),
    url("../../assets/four.jpeg"), lightgray 90% / cover no-repeat;
  //background: linear-gradient(0deg, rgb(0, 0, 0) 0%, rgb(0, 0, 0) 100%), lightgray 50% / cover no-repeat;
}
</style>



// WEBPACK FOOTER //
// src/components/package/newPropertiesSection.vue